var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProvasSp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174,
    height: 115.852,
    viewBox: "0 0 174 115.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.001,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.001,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.001,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1",
    transform: "translate(7.632 7.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_98",
    "data-name": "Grupo 98",
    transform: "translate(-7.632 -7.623)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 37.488)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 11.384, 37.488)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 22.767, 37.489)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 34.151, 37.489)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_281",
    "data-name": "Caminho 281",
    d: "M237.162,165.915a3.6,3.6,0,1,0,3.214,3.214,3.6,3.6,0,0,0-3.214-3.214Z",
    transform: "translate(-186.173 -132.016)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_282",
    "data-name": "Caminho 282",
    d: "M295.463,165.915a3.6,3.6,0,1,0,3.214,3.214,3.6,3.6,0,0,0-3.214-3.214Z",
    transform: "translate(-233.09 -132.016)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_283",
    "data-name": "Caminho 283",
    d: "M353.762,165.915a3.6,3.6,0,1,0,3.214,3.214,3.6,3.6,0,0,0-3.214-3.214Z",
    transform: "translate(-280.006 -132.016)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_19",
    "data-name": "Elipse 19",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 11.382, 26.693)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_20",
    "data-name": "Elipse 20",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 22.766, 26.691)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_21",
    "data-name": "Elipse 21",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 34.149, 26.691)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_284",
    "data-name": "Caminho 284",
    d: "M237.162,110.615a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,237.162,110.615Z",
    transform: "translate(-186.173 -87.514)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_285",
    "data-name": "Caminho 285",
    d: "M295.463,110.615a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,295.463,110.615Z",
    transform: "translate(-233.09 -87.514)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_286",
    "data-name": "Caminho 286",
    d: "M353.762,110.615a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,353.762,110.615Z",
    transform: "translate(-280.006 -87.514)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_22",
    "data-name": "Elipse 22",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "translate(11.383 15.893) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_23",
    "data-name": "Elipse 23",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "translate(22.766 15.894) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_24",
    "data-name": "Elipse 24",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "translate(34.15 15.893) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_287",
    "data-name": "Caminho 287",
    d: "M237.162,55.315a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,237.162,55.315Z",
    transform: "translate(-186.173 -43.012)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_288",
    "data-name": "Caminho 288",
    d: "M295.463,55.315a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,295.463,55.315Z",
    transform: "translate(-233.09 -43.012)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_25",
    "data-name": "Elipse 25",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "translate(22.767 5.097) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_26",
    "data-name": "Elipse 26",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "translate(34.152 5.099) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_289",
    "data-name": "Caminho 289",
    d: "M295.463.015a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,295.463.015Z",
    transform: "translate(-233.09 1.491)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_290",
    "data-name": "Caminho 290",
    d: "M353.762,55.315a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,353.762,55.315Z",
    transform: "translate(-280.006 -43.012)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_27",
    "data-name": "Elipse 27",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 79.687, 37.491)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_291",
    "data-name": "Caminho 291",
    d: "M237.162,221.215a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,237.162,221.215Z",
    transform: "translate(-186.173 -176.518)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_292",
    "data-name": "Caminho 292",
    d: "M295.463,221.215a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,295.463,221.215Z",
    transform: "translate(-233.09 -176.518)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_293",
    "data-name": "Caminho 293",
    d: "M237.162,276.515a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,237.162,276.515Z",
    transform: "translate(-186.173 -221.021)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_294",
    "data-name": "Caminho 294",
    d: "M295.463,276.515a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,295.463,276.515Z",
    transform: "translate(-233.09 -221.021)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_295",
    "data-name": "Caminho 295",
    d: "M295.463,331.805a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,295.463,331.805Z",
    transform: "translate(-233.09 -265.515)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_296",
    "data-name": "Caminho 296",
    d: "M353.762,221.215a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,353.762,221.215Z",
    transform: "translate(-280.006 -176.518)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_28",
    "data-name": "Elipse 28",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 79.685, 48.289)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_297",
    "data-name": "Caminho 297",
    d: "M470.363,165.915a3.6,3.6,0,1,0,3.214,3.214,3.6,3.6,0,0,0-3.214-3.214Z",
    transform: "translate(-373.84 -132.016)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_298",
    "data-name": "Caminho 298",
    d: "M470.363,110.615a3.6,3.6,0,1,0,3.214,3.214A3.6,3.6,0,0,0,470.363,110.615Z",
    transform: "translate(-373.84 -87.514)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_29",
    "data-name": "Elipse 29",
    cx: 3.604,
    cy: 3.593,
    rx: 3.604,
    ry: 3.593,
    transform: "translate(102.451 37.497) rotate(-45.06)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_299",
    "data-name": "Caminho 299",
    d: "M442.5,298.743H349.95l4.483-18.323h92.423Z",
    transform: "translate(-287.762 -231.801)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "PROVAS_DE",
    "data-name": "PROVAS DE",
    transform: "translate(63.602 64.677)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "Gobold-Italic, Gobold",
    fontStyle: "italic",
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRO"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.08em"
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "AS DE")), /*#__PURE__*/React.createElement("text", {
    id: "S\\xC3O_PAULO",
    "data-name": "S\\xC3O PAULO",
    transform: "translate(1.696 103.229)",
    fill: "#fff",
    fontSize: 30,
    fontFamily: "GoboldBold-Italic, Gobold",
    fontStyle: "italic",
    letterSpacing: "0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S\xC3O "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.02em"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "AULO")), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_300",
    "data-name": "Caminho 300",
    d: "M576.747,73.887H579.5l1.74-8.172h.447a6.779,6.779,0,0,0,1.874-.2,4.739,4.739,0,0,0,3.45-3.809l.6-2.866a6.552,6.552,0,0,0,.166-1.371q0-2.633-2.974-2.644h-4l-4.052,19.065Zm6.229-16.353h.972q.972,0,.972.855a2.01,2.01,0,0,1-.059.447l-.6,2.866a1.542,1.542,0,0,1-1.011,1.215,2.836,2.836,0,0,1-.806.078h-.631ZM589.2,73.887l1.769-8.337.359-.049.7,8.386h3.013l-1.2-8.872a4.2,4.2,0,0,0,2.876-3.314l.6-2.866a6.557,6.557,0,0,0,.166-1.371q0-2.633-2.974-2.644h-4l-4.052,19.065h2.749Zm3.479-16.353h.972q.972,0,.972.855a2.01,2.01,0,0,1-.059.447l-.6,2.866a1.542,1.542,0,0,1-1.011,1.215,2.837,2.837,0,0,1-.806.078h-.631Zm3.964,16.353L600.7,54.822h2.749L599.4,73.887Zm5.325,0,4.052-19.065h2.749l.252,11.057,2.351-11.057h2.546L609.87,73.887h-2.749l-.232-10.708-2.275,10.708h-2.644Zm12.223,0,3.48-16.353H615.1l.574-2.71h7.9L623,57.534h-2.576l-3.479,16.353Zm-23.5,2.831-4.052,19.065H583.9l4.052-19.065H590.7Zm10.476,0-4.052,19.065h-2.749l-.232-10.708-2.275,10.708h-2.644l4.052-19.065h2.749l.252,11.057,2.351-11.057h2.546Zm-.078,12.33-2.322,6.734h2.769l1.4-4.042h2.808l-.32,4.042h2.779l.545-6.764.679-12.3h-3.77Zm4.878-.029h-2.1l2.73-7.929Zm11.592,4.052-.574,2.71h-7.133l4.052-19.065h2.749l-3.48,16.353h4.382ZM586.406,76.718v.01s-.432,2.823-2.536,2.823h-2.14a.2.2,0,0,0-.2.162l-.246,1.2-.621,2.935-.107.512a.2.2,0,0,0,.2.246h3.138a.2.2,0,0,1,.2.246l-.012.053-.605,2.823a.2.2,0,0,1-.2.16h-3.31a.2.2,0,0,0-.2.162l-1.6,7.568a.2.2,0,0,1-.2.162h-2.9a.2.2,0,0,1-.2-.246l1.533-7.228a.2.2,0,0,0-.2-.246c-1.121,0-2.243,0-3.364.006-.371,0-.8,0-.808-.492s.426-.508.791-.512c.875-.01,1.75,0,2.626-.01.3,0,.7.01.713-.4s-.394-.406-.7-.437c-.228-.025-.463-.012-.7-.021-.332-.014-.644-.084-.631-.5s.344-.457.666-.469c.205-.008.412-.006.617,0h1.47a.2.2,0,0,0,.2-.162l.2-.957a.2.2,0,0,0-.2-.246q-2.024,0-4.046,0c-.18,0-.361,0-.541,0-.369-.016-.678-.131-.689-.562-.014-.455.314-.543.68-.545,1,0,2.007,0,3.011,0,.463,0,.926-.037,1.388-.049.256-.006.494-.078.513-.355.023-.322-.234-.433-.508-.463a6.853,6.853,0,0,0-.693-.023q-3.128,0-6.254,0a6.292,6.292,0,0,1-.693-.02c-.369-.039-.666-.2-.633-.623.031-.4.363-.463.683-.463,1.57-.008,3.14,0,4.71-.006.617,0,1.236,0,1.853-.012.3-.006.613-.092.627-.439.016-.383-.336-.391-.615-.43-.1-.014-.205-.012-.308-.025-.338-.045-.611-.189-.6-.572s.295-.512.638-.515c.617-.008,1.236.01,1.853-.016.385-.016.98.137,1-.424s-.576-.455-.965-.465c-.746-.018-1.494.006-2.24-.01-.406-.008-.922.023-.931-.553-.01-.594.5-.551.912-.553q1.807,0,3.616,0h7.543Zm-15.453,2.521a.5.5,0,0,1,.521-.473c.41-.021.822-.006,1.234-.006v0c.385,0,.771-.018,1.156.006a.485.485,0,0,1,.5.488.494.494,0,0,1-.451.541,10.816,10.816,0,0,1-2.462.018.514.514,0,0,1-.5-.578Zm1.31,7a7.521,7.521,0,0,1-.84-.006.5.5,0,0,1-.5-.558.479.479,0,0,1,.517-.461c.56-.006,1.121.008,1.681.035.318.016.541.184.523.531-.018.322-.262.412-.539.422s-.56,0-.842,0v.037ZM577.952,57.7a6.054,6.054,0,0,1-.152,1.281l-.566,2.665h-3.269l.6-2.81a1.625,1.625,0,0,0,.037-.328c0-.424-.269-.463-.568-.465h-.016a.941.941,0,0,0-.7.244,1.3,1.3,0,0,0-.33.691l-.346,1.617a.925.925,0,0,0-.019.2,1.284,1.284,0,0,0,.08.424,4.2,4.2,0,0,0,1.105,1.5c.156.148.324.3.51.457.078.066.152.133.227.2a5.677,5.677,0,0,1,.56.594,4.594,4.594,0,0,1,.5.748,4.033,4.033,0,0,1,.473,1.906,4.848,4.848,0,0,1-.107,1l-.482,2.253c-.568,2.667-2.189,4.02-4.819,4.02a5.913,5.913,0,0,1-.7-.039,3.408,3.408,0,0,1-1.72-.615,2.272,2.272,0,0,1-.611-.7,3.046,3.046,0,0,1-.355-1.392c0-.045,0-.09,0-.137v-.117h-.043l.059-.275c.014-.16.033-.326.063-.5a.206.206,0,0,0-.183-.115c-1.121,0-2.244,0-3.364.006-.373,0-.8,0-.808-.494s.426-.508.791-.512c.875-.01,1.751,0,2.626-.01.3,0,.7.01.713-.4s-.394-.406-.7-.437c-.23-.025-.463-.012-.7-.021-.332-.014-.644-.084-.631-.5s.344-.457.666-.469c.205-.008.412-.006.617,0,.49,0,1.6-.092,1.6-.092h2.8a1.1,1.1,0,0,1,.441.041,23.776,23.776,0,0,1-.57,2.769,1.637,1.637,0,0,0-.037.338.448.448,0,0,0,.09.32.636.636,0,0,0,.484.137c.58,0,.9-.289,1.035-.935l.437-2.04a1.035,1.035,0,0,0,.027-.23,2.407,2.407,0,0,0-.68-1.457,6.943,6.943,0,0,0-.633-.656c-.117-.107-.24-.219-.373-.33a4.951,4.951,0,0,1-1.4-1.8,4.022,4.022,0,0,1-.324-1.256H564.93c-.18,0-.361,0-.541,0-.369-.016-.677-.131-.689-.562-.014-.455.314-.545.68-.545,1,0,2.007,0,3.013,0,.463,0,.925-.037,1.388-.049.256-.006.494-.078.513-.355.023-.322-.234-.433-.508-.463a6.852,6.852,0,0,0-.693-.023q-3.128,0-6.256,0a6.344,6.344,0,0,1-.7-.02c-.369-.039-.666-.2-.633-.623.031-.4.363-.463.685-.465,1.57-.008,3.14,0,4.712-.008.617,0,1.236,0,1.853-.012.3-.006.613-.092.627-.439.016-.383-.336-.391-.615-.43-.1-.014-.205-.012-.308-.025-.338-.045-.611-.189-.6-.572s.295-.512.638-.515c.617-.008,1.236.01,1.853-.016.385-.016.98.137,1-.424s-.576-.455-.965-.465c-.746-.018-1.494.006-2.24-.01-.406-.008-.922.023-.931-.553-.01-.594.5-.551.912-.553q1.807,0,3.616,0h3.823c1.9,0,2.777.721,3.148,1.593a3.286,3.286,0,0,1,.236,1.283Zm-15.117-.353a.5.5,0,0,1,.521-.473c.41-.021.822-.006,1.234-.006v0c.385,0,.771-.018,1.156.006a.485.485,0,0,1,.5.488.5.5,0,0,1-.451.543,10.816,10.816,0,0,1-2.462.018.514.514,0,0,1-.5-.578Zm.473,7a.5.5,0,0,1-.5-.558.48.48,0,0,1,.517-.461c.56-.006,1.123.008,1.681.035.318.016.541.184.523.531-.018.322-.262.412-.539.422s-1.4.062-1.681.031Z",
    transform: "translate(-457.206 -50.251)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvasSp);
export default __webpack_public_path__ + "static/media/provasSp.1448b336b9e09dd68605d71dda68fd5b.svg";
export { ForwardRef as ReactComponent };